// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pre-swap-warning[data-v-603570ce] {\r\n  font-weight: bold;\r\n  font-style: italic;\r\n  color: var(--yellow-900);\n}\n.subscription-card[data-v-603570ce] {\r\n  max-width: 300px;\n}\r\n", ""]);
// Exports
module.exports = exports;
